module.exports = __webpack_public_path__ + "img/VsShimmer3.975b223b.jpg";